export default __webpack_public_path__ + "static/media/resend-email.19cd9c85.png";